<template>
  <div>
    <div
      class="level2"
      v-for="v in childrenMenu"
      :key="v.id"
      @click="goLink(v)"
      :class="{ active: '/' + v.path == path }"
      v-if="v.hiden == 1"
    >
      {{ v.title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    children: {
      type: Array,
      default: [],
    },
  },
  computed: {
    //二级菜单过滤
    childrenMenu() {
      return this.children.filter((v) => v.type == 1);
    },
    //当前路由
    path() {
      return this.$route.path;
    },
  },
  methods: {
    goLink(v) {
      if ("/" + v.path == this.path) {
        return;
      }
      this.$router.replace("/" + v.path);
    },
  },
};
</script>

<style scoped>
.level2 {
  width: 180px;
  height: 50px;
  padding: 0 10px;
  box-sizing: border-box;
  line-height: 50px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #585f6a;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.active {
  color: #0073ff;
}
</style>